import { IconButton } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export default function ViewAssignmentButton({assignment}) {
    return (
        <a 
            href={`https://adminblewinc.quickbase.com/db/bqdahkuuf?a=dr&rid=${assignment?.['3']}&rl=i6q`}
            target="_blank" 
            rel="noopener noreferrer" 
            style={{textDecoration: 'none'}}
        >
            <IconButton     
                size="small" 
                sx={{color: '#1976d2'}}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <VisibilityOutlinedIcon sx={{fontSize: "14px"}}/>
            </IconButton>
        </a>
    )
}